<template>
  <div class="space-y-8">
    <SectionHeader :title="__('Experience')">
      <template #icon>
        <Icon class="text-3xl text-primary" name="business_center" is-filled />
      </template>
    </SectionHeader>

    <div class="shadow-element space-y-8 rounded-2xl bg-white p-6 md:p-8">
      <Experience
        v-for="experience in isListExpanded ? data : data.slice(0, 3)"
        :key="experience.id"
        :experience="experience"
      />

      <Button
        v-if="data.length > 3"
        class="mx-auto"
        variant="outline"
        @click="handleExpandListButtonClick"
      >
        {{ isListExpanded ? __('See less') : __('See more') }}
      </Button>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { SectionHeader } from '@/pages/components/section-header';
  import { Experience } from './components/experience';
import { __ } from '../../../../../helpers';

  const props = defineProps({
    data: {
      type: Array,
      required: true
    }
  });

  const isListExpanded = ref(false);

  function handleExpandListButtonClick() {
    isListExpanded.value = !isListExpanded.value;
  }
</script>
